// poor man's feature flags
import { difference } from "lodash-es";

import flagsData from "../../../../featureFlags.json";

export enum Environment {
  Development = "development",
  Staging = "staging",
  Production = "production",
  Test = "test",
}

export enum Feature {
  Bnpl = "bnpl",
  HotelsPersistentSearch = "hotelsPersistentSearch",
  CabinClassInOffer = "cabinClassInOffer",
  AdditionalServiceSelection = "additionalServiceSelection",
  HotelsFlow = "hotelsFlow",
  TripsFlow = "tripsFlow",
}

type FeatureFlags = Record<Environment, Record<Feature, boolean>>;

const parseFlagsData = (): FeatureFlags => {
  const supportedEnvironments = Object.values<string>(Environment);
  const supportedFeatures = Object.values<string>(Feature);

  if (difference(Object.keys(flagsData), supportedEnvironments).length > 0) {
    throw new Error(
      `Not supported environment set in features flags data.
      Supported environments: ${supportedEnvironments.join(", ")}`,
    );
  }

  if (
    Object.values(flagsData).some(
      (flags) => difference(Object.keys(flags), supportedFeatures).length > 0,
    )
  ) {
    throw new Error(
      `Not supported feature flag set in features flags data.
      Supported features: ${supportedFeatures.join(", ")}`,
    );
  }

  return flagsData;
};

const flags = parseFlagsData();

const getCurrentEnvironment = (): Environment => {
  const currentEnvironment = import.meta.env.VITE_PUBLIC_ENVIRONMENT;

  if (!currentEnvironment) {
    throw new Error("VITE_PUBLIC_ENVIRONMENT env var is not set.");
  }

  if (currentEnvironment === "uat") {
    return Environment.Production;
  }

  const supportedValues = Object.values<string>(Environment);
  if (!supportedValues.includes(currentEnvironment)) {
    throw new Error(
      `VITE_PUBLIC_ENVIRONMENT is set to not supported value.
      Supported values: ${supportedValues.join(", ")}
      Detected value: ${currentEnvironment}`,
    );
  }

  return currentEnvironment as Environment;
};

export const isFeatureEnabled = (feature: Feature): boolean => {
  const currentEnvironment = getCurrentEnvironment();

  return Boolean(flags[currentEnvironment]?.[feature]);
};

export const isFeatureDisabled = (feature: Feature): boolean => {
  return !isFeatureEnabled(feature);
};
